import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Anexo1 = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-a1" className={classes.title}>
                ANEXO I – Calendário Oficial da {edicao}ª Olimpíada de Professores da OBMEP Mirim
            </Title>

            <Grid 
                container 
                align='center' 
                direction="row" 
                justify="center"
                alignItems="center"
            >
                <Grid item >
                    <TableContainer component="div">
                        <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" colSpan={2} className={classes.backGray}><span className={classes.item}>{edicao}ª Olimpíada de Professores da OBMEP Mirim</span></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>04 de maio a 29 de maio</span></TableCell>
                                    <TableCell align="center">
                                        Período de inscrições <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>03 de agosto a 14 de agosto</span></TableCell>
                                    <TableCell align="center">
                                        Período para confirmação de participação <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>03 de agosto a 14 de agosto</span></TableCell>
                                    <TableCell align="center">
                                        Período para solicitação de prova em trânsito <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>28 de agosto</span></TableCell>
                                    <TableCell align="center">
                                        Divulgação dos locais de prova <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.blue}><span className={classes.item}>17 de outubro</span></TableCell>
                                    <TableCell align="center" className={classes.blue} >PROVA</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>01 de dezembro</span></TableCell>
                                    <TableCell align="center">
                                        Divulgação das notas da prova (a partir de 12:00h Horário de Brasília) <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>01 de dezembro a 03 de dezembro</span></TableCell>
                                    <TableCell align="center">
                                        Período para solicitação de revisão de nota (a partir de 12:00h do dia 1/12 a 22:00h do dia 3/12) (Horário de Brasília) <br />
                                        (exclusivamente em professores.olimpiadamirim.obmep.org.br)
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" width='35%' component="th" scope="row" className={classes.green}><span className={classes.item}>15 de dezembro</span></TableCell>
                                    <TableCell align="center">Divulgação dos premiados (exclusivamente em professores.olimpiadamirim.obmep.org.br)</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default Anexo1;